import { PRIMARY, SECONDARY } from '../styles';

export default {
  wrapper: {
    marginBottom: 80,
  },
  noDataRow: {
    textAlign: 'center',
    color: 'lightgrey',
    fontSize: 24,
  },
  noData: {
    fontSize: 250,
    color: 'lightgrey',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
  },
  paper: {
    flex: 1,
    margin: 10,
    padding: 20,
    borderLeftColor: SECONDARY,
    borderLeftWidth: 10,
    borderLeftStyle: 'solid',
  },
  paperNarrow: {
    flex: 0.7,
    margin: 10,
    padding: 20,
    borderLeftColor: SECONDARY,
    borderLeftWidth: 10,
    borderLeftStyle: 'solid',
  },
  paperTitle: {
    fontSize: 18,
    color: PRIMARY,
    fontWeight: 'bold',
  },
  paperBody: {
    fontSize: 60,
    color: PRIMARY,
    fontWeight: 'bold',
  },
  paperBodySmall: {
    fontSize: 22,
    color: 'lightgrey',
    fontWeight: 'bold',
    flex: 1,
  },
  month: {
    fontSize: 24,
    color: PRIMARY,
    fontWeight: 'bold',
  },
  paid: {
    color: 'white',
    backgroundColor: 'green',
    paddingLeft: 8,
    paddingRight: 8,
  },
  outstanding: {
    color: 'white',
    backgroundColor: 'red',
  },
  fromCol: {
    width: 120,
  },
  toCol: {
    width: 120,
  },
  accountsCol: {
    width: 110,
  },
  tasksCol: {
    width: 110,
  },
  taskCostCol: {
    width: 110,
  },
  amountCol: {
    width: 110,
  },
  statusCol: {
    width: 120,
  },
  actionCol: {
    width: 120,
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
  },
};



// WEBPACK FOOTER //
// ./src/components/Billing/styles.js